import moment from 'moment'

export const fetchFrequencyOptions = [
  { label: 'One time', value: 'one_time' },
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
]

export const fetchDaysOptions = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
]

export const fetchTimeOptions = Array(48)
  // @ts-ignore
  .fill()
  .map((_, index) =>
    moment({
      hour: Math.floor(0.5 * index),
      minute: 30 * (index % 2),
    }).format('h:mm A'),
  )
  .map((hour) => ({
    label: hour,
    value: hour,
  }))
